import React, {  useState, useEffect, createContext} from 'react';
import { Route, Routes, useNavigate, NavLink} from 'react-router-dom';


import AppMode from './appMode/appMode';

import UserHeader from './user/userHeader';
import RoleHeader from './role/roleHeader';
import PrinterHeader from './printer/printerHeader';
import ScaleHeader from './scale/scaleHeader';
import License from './license/license';
import DevGeneralSetting from './devGeneral/devGeneralSetting';
import DevRole from './devRole/devRole';
import { FcSupport, FcManager, FcExport  , FcReadingEbook, FcPrint, FcTimeline } from "react-icons/fc";

function DevTab(props) {

  const [activeTab, setActiveTab] = useState('appMode');

  const navigate = useNavigate();

  useEffect(() => {

    navigate('/devTab/appMode');

  }, []);


  return (
    <div className="card" style={{paddingTop : '0px', userSelect: 'none'}}>
      
      <div>

        <NavLink to="appMode"  onClick={() => setActiveTab('appMode')}>
        <div className={`${activeTab === 'appMode' ? 'tab-two active-link' : 'tab-two'}`}>
          <FcSupport size={35}/>
            <span className="tab-text">App Mode</span>
          </div>
        </NavLink>
        
        <NavLink to="general"  onClick={() => setActiveTab('general')}>
        <div className={`${activeTab === 'general' ? 'tab-two active-link' : 'tab-two'}`}>
          <FcManager size={35}/>
            <span className="tab-text">General</span>
          </div>
        </NavLink>

        <NavLink to="role" className={({isActive}) => (isActive ? "active-user" : 'none')}>
          <div className="tab-three" style={{width: '12%'}}>
          <FcReadingEbook size={35}/>
            <span className="tab-text">Permissions</span>
          </div>
        </NavLink>
    
      
      <NavLink to="printer" className={({isActive}) => (isActive ? "active-user" : 'none')}>
          <div className="tab-four" style={{width: '12%'}}>
          <FcPrint size={35}/>
            <span className="tab-text">Printer</span>
          </div>
        </NavLink>

              
      <NavLink to="scale" className={({isActive}) => (isActive ? "active-user" : 'none')}>
          <div className="tab-five" style={{width: '12%'}}>
          <FcTimeline size={35}/>
            <span className="tab-text">Scale</span>
          </div>
        </NavLink>

        <NavLink to="license" className={({isActive}) => (isActive ? "active-user" : 'none')}>
          <div className="tab-six" style={{width: '12%'}}>
          <FcTimeline size={35}/>
            <span className="tab-text">License</span>
          </div>
        </NavLink>

        
          <NavLink to="devRole" onClick={() => setActiveTab('devRole')}>
            <div className={`${activeTab === 'devRole' ? 'tab-three active-link' : 'tab-three'}`} style={{ width: '10%' }}>
              <FcReadingEbook size={35} />
              <span className="tab-text">Roles</span>
            </div>
          </NavLink>
       

     


      </div>

      

 
      <Routes>

        <Route path='appMode' element= {<AppMode/>}/>
        
        <Route path='general' element= {<DevGeneralSetting/>}/>
        <Route path='role' element= {<RoleHeader/>}/>
        <Route path='printer' element= {<PrinterHeader/>}/>
        <Route path='scale' element= {<ScaleHeader/>}/>
        <Route path='license' element= {<License/>}/>
        <Route path='devRole' element={<DevRole />} /> 
      </Routes>

    </div>
  );
}

export default DevTab;
